/** WUBRG mana color hex values */
export const WUBRG_COLORS: Record<string, string> = {
  W: '#F9FAF4',
  U: '#0E68AB',
  B: '#150B00',
  R: '#D3202A',
  G: '#00733E',
};

/** Standard WUBRG color order */
export const WUBRG_ORDER: readonly string[] = ['W', 'U', 'B', 'R', 'G'];

/** Bracket number to display color */
export const BRACKET_COLORS: Record<number, string> = {
  1: 'var(--bracket-1)',
  2: 'var(--bracket-2)',
  3: 'var(--bracket-3)',
  4: 'var(--bracket-4)',
  5: 'var(--bracket-5)',
};

/** Bracket number to short tier label */
export const BRACKET_LABELS: Record<number, string> = {
  1: 'Exhibition',
  2: 'Core',
  3: 'Upgraded',
  4: 'Optimized',
  5: 'cEDH',
};

/** How many reads-as chips the deck header shows before "+N more" (theme discovery, 2026-10-23). */
export const READS_AS_SHOWN = 6;
